;(function (angular) {
  'use strict'

  angular.module('kilo.routes.product-pack.show', [])
  .config(RouteConfigurator)

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'product-pack.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        productPack: ['$stateParams', 'ProductPackManager', function ($stateParams, ProductPackManager) {
          return ProductPackManager.findById($stateParams.id, ProductPackManager.query({ populate: 'products.product' }))
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show.template.html',
          controller: 'ProductPackShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show-toolbar.html',
          controller: 'ProductPackShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.label}}',
        parent: 'product-pack.list'
      }
    }

    var newState = {
      name: 'product-pack.new',
      url: '/new',
      resolve: {
        productPack: ['ProductPackManager', function (ProductPackManager) {
          return ProductPackManager.create()
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show.template.html',
          controller: 'ProductPackShowController',
          controllerAs: 'show'
        }
      },
      ncyBreadcrumb: {
        label: 'Nouveau pack produits',
        parent: 'product-pack.list'
      }
    }

    $stateProvider.state(showState).state(newState)
  }
})(window.angular)
